(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("component-emitter"));
	else if(typeof define === 'function' && define.amd)
		define(["component-emitter"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("component-emitter")) : factory(root["component-emitter"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, function(__WEBPACK_EXTERNAL_MODULE__8__) {
return 